import React from 'react'
import StorageService from './../../../shared/services/Storage.service'
import UserProfileService from './../../../shared/services/UserProfile.service'
import Store from './../store'

const getUserId = () => {
  try {
    return UserProfileService.getUserId(true)
  } catch (ex) {
    return false
  }
}

export default class CacheBuster extends React.Component {
  state = {
    isLoading: true, // Is fetching meta.json content.
    isLatestVersion: false, // Boolean indicator.
    availVersion: null, // Whats found in meta.json.
    runningVersion: null, // Whats stored in cookie.
  }

  checkInterval = null

  checkVersion = () => {
    // Fetch the lastest version indicated in the
    // meta.json remote file (updates at time of deployment).
    Store.fetchVersionMeta()
      .then(meta => {
        // Get the version ## from meta response & the
        // current version stored in the cookie.
        let isLatestVersion = true
        const availVersion = meta?.version,
          runningVersion =
            Store.USE_COOKIE_VERSION === true ? Store.getCookie('cookie_app_version') : global?.appVersion

        // If the current version was not available,
        // update `isLatestVersion` flag to prompt reload.
        if (typeof runningVersion === 'undefined' || runningVersion === '') isLatestVersion = false
        // If the latest version could not be determined, fail closed: leave
        // isLatestVersion true (no reload, no link) rather than pass a null into
        // semverHasChanged (which would throw).
        else if (!availVersion) isLatestVersion = true
        // If the latest version is different than the current
        // version, update `isLatestVersion` flag to prompt reload.
        else if (Store.semverHasChanged(availVersion, runningVersion)) isLatestVersion = false

        // Login "Update My Backoffice" link signal — Rule A ("any difference"),
        // the same test the reload path uses. Shows whenever the running bundle
        // differs from the declared latest, in EITHER direction, so it also
        // surfaces on a rollback (running ahead of the target). False positives
        // are prevented upstream by keeping the version sources in lockstep at
        // deploy time, not by narrowing this comparison. Captured here before the
        // reload safety-net below can force isLatestVersion true.
        Store.setUpdateAvailable(!isLatestVersion)

        // console.log("runningVersion", runningVersion)
        // console.log("semverHasChanged", Store.semverHasChanged(availVersion, runningVersion))
        // console.log("isLatestVersion", isLatestVersion)

        // Reset check_version_count on successful version match
        if (isLatestVersion) {
          StorageService.clear('check_version_count')
          Store.setSafetyNet(false)
        }

        // Run a safety net to prevent an infinite refresh loop
        if (!isLatestVersion) {
          let count = StorageService.get('check_version_count')
          // Parse count, defaulting to 0 if invalid
          const currentCount =
            count === null || count === undefined || count === '' || isNaN(parseInt(count)) ? 0 : parseInt(count)

          // console.log('[Version Check]', {
          //   currentCount,
          //   availVersion,
          //   runningVersion,
          //   willIncrement: currentCount < 3
          // })

          // Check safety net BEFORE incrementing
          if (currentCount >= 3) {
            isLatestVersion = true
            Store.setSafetyNet(true)
            console.warn('[warn.esn] Safety net activated - stopping reload loop', {
              user_id: getUserId(),
              availVersion,
              runningVersion,
              USE_COOKIE_VERSION: Store.USE_COOKIE_VERSION === true,
              check_count: currentCount,
            })
          } else {
            // Only increment if safety net hasn't been reached
            const newCount = currentCount + 1
            console.log('[Version Check] Incrementing counter:', currentCount, '->', newCount)
            StorageService.set('check_version_count', newCount)
          }
        }

        return this.setState({
          isLoading: false,
          isLatestVersion,
          availVersion,
          runningVersion,
        })
      })
      .catch(err => {
        console.error('Failed to fetch version meta:', err)
        // Fail CLOSED: if we can't determine the latest version, do NOT nag the
        // customer — hide the update link rather than risk a false positive.
        Store.setUpdateAvailable(false)
        // On error, still set loading to false to prevent app from hanging
        this.setState({
          isLoading: false,
          isLatestVersion: true,
          availVersion: null,
          runningVersion: null,
        })
      })
  }

  componentDidMount() {
    // 1. Clear any previous version check flags.
    StorageService.clear('check_version')

    // 2. Perform initial version check
    this.checkVersion()

    // 3. Set up periodic re-checking every 10 minutes (600000ms)
    // This ensures we catch version updates even if user has page open during deployment
    this.checkInterval = setInterval(() => {
      this.checkVersion()
    }, 600000) // 10 minutes
  }

  componentWillUnmount() {
    // Clear interval when component unmounts
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
      this.checkInterval = null
    }
  }

  render() {
    return this.props.children(this.state)
  }
}
